import { memo, useMemo, useRef, useState } from 'react';
import formaters from '../formaters';

import { useField } from 'formik';

import styled from 'styled-components';
import { Label } from '..';

const InputStyled = styled.input`
  width: 100%;
  height: 24px;
  border: 0;
  outline: none;
  color: #333 !important;
  font-size: 14px;
  font-weight: 400;

  &:disabled {
    color: #707070;
    background-color: #fff;
  }
`

const InputOutlined = styled.input`
  width: 181px;
  padding: 14px 0;
  text-align: center;
  outline: none;
  border: 1px solid #707070;
  border-radius: 4px;
  text-transform: uppercase;
  color: #161414;
  font-size: 14px;
  font-weight: 400;
`

const FormInputGroup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  border-bottom: 1px solid ${({disabled}) => disabled ? '#CBCBCB' : '#333333'};
  padding-bottom: 4px;
`;

const FormToggleTypeButton = styled.div`
  width: 10%;
  cursor: pointer;
`

const Input = ({
  formater,
  children,
  label = null,
  forceTogglePassword = false,
  variant = "line",
  mask = null,
  ...props
}) => {
  const [field] = useField(props);
  const transform = useMemo(() => (formaters[formater] || formaters._default)(mask), [formater, mask]);
  const inputRef = useRef();

  const [type, setType] = useState(props.type || 'text');

  if(variant === "outlined") {
    return <InputOutlined {...field} {...props} value={transform(field.value)} type={type} />
  }
  return (
    <>
      {label && <Label onClick={() => inputRef.current.focus()}>{label}</Label>}
      <FormInputGroup disabled={props.disabled || false}>
        <InputStyled ref={inputRef} {...field} {...props} value={transform(field.value)} type={type} />
        {children}
        {(props?.type === 'password' || forceTogglePassword) && (
          <FormToggleTypeButton onClick={() => setType(state => state === 'password' ? 'text' : 'password')}>
            <img src="https://zonasul.vtexassets.com/arquivos/olho.svg" alt="olho" />
          </FormToggleTypeButton>
        )}
      </FormInputGroup>
    </>
  );
}

export default memo(Input);
